import React, { useRef } from 'react'
import { AriaButtonProps, mergeProps, useButton, useLink } from 'react-aria'
import { AriaProps } from '../types'
import { splitAriaProps } from '../helpers'

export const useButtonProps = ({
  isDisabled,
  type,
  onClick,
  INTERNAL_nativeOnClick,
  ...ariaProps
}: {
  INTERNAL_nativeOnClick?: (event: React.MouseEvent) => void
  isDisabled?: boolean
  onClick?: AriaButtonProps['onPress']
  type?: 'button' | 'submit' | 'reset'
} & AriaProps) => {
  const { elementRef, reactAriaProps, domProps } = splitAriaProps(ariaProps)
  const fallbackRef = useRef<HTMLButtonElement>(null)
  const ref = elementRef ?? fallbackRef
  const { buttonProps } = useButton(
    {
      elementType: 'button',
      type: type,
      onPress: onClick,
      isDisabled: isDisabled,
      ...reactAriaProps,
    },
    ref
  )
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { color: _color, ...propsWithoutColor } = mergeProps(
    !isDisabled ? { onClick: INTERNAL_nativeOnClick } : {},
    buttonProps
  )
  return { ref, buttonProps: mergeProps(propsWithoutColor, domProps) }
}

export const useAnchorProps = ({
  isDisabled,
  onClick,
  INTERNAL_nativeOnClick,
  ...ariaProps
}: {
  INTERNAL_nativeOnClick?: (event: React.MouseEvent) => void
  isDisabled?: boolean
  onClick?: AriaButtonProps['onPress']
} & AriaProps) => {
  const ref = useRef<HTMLAnchorElement>(null)
  const { linkProps } = useLink(
    {
      isDisabled: isDisabled,
      onPress: onClick,
      ...ariaProps,
      elementType: 'a',
    },
    ref
  )
  return {
    ref,
    anchorProps: mergeProps(!isDisabled ? { onClick: INTERNAL_nativeOnClick } : {}, linkProps),
  }
}
